module.exports = __webpack_public_path__ + "img/shijingtu.381b8434.webp";